<template>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center vertical">
      <div class="col-lg-6 col-xl-5">

        <h1>Forgot Password</h1>
        <div class="box">
          <b-alert :show="message !== ''" variant="success">
            {{ message }}
          </b-alert>

          <b-form @submit.prevent="forgot">
            <b-form-group label="Send Password Reset">
              <b-form-input
                type="email" name="email"
                maxlength="255" required trim
                v-model="data.email"
                :state="errors.email ? false : null"
                :disabled="loading"
                placeholder="name@email.com"
              ></b-form-input>

              <b-form-invalid-feedback v-if="errors.email">
                {{ errors.email[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

            <div class="row">
              <div class="col-md-6 left-then-center order-md-1 order-2 mt-4">
                <router-link class="btn btn-block btn-sm" to="/dashboard">
                  Back to Login
                </router-link>
              </div>

              <div class="col-md-6 order-1">
                <button class="btn btn-secondary btn-block btn-lg pl-0 pr-0" type="submit">
                  Send Reset
                </button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      data: {
        email: ''
      },
      errors: {},
      loading: false,
      message: ''
    }
  },
  methods: {
    forgot () {
      this.loading = true
      this.message = ''

      this.$http
        .post('password/forgot', { email: this.data.email })
        .then(
          () => {
            this.message = 'An email has been sent. Please see the email for additional instructions.'
          },
          (res) => {
            this.errors = res.response.data.errors
          }
        )
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
